import { PluginKey } from "@tiptap/pm/state";
import type { IconName } from "@salestrak/ui";
import type { EntityKind } from "#app/lib/entity-visuals";
import type { EntitySuggestionSource } from "./entity-mention";

// ProseMirror throws on duplicate plugin keys, so create them once at load.
const PEOPLE_KEY = new PluginKey("mentionPeople");

// Seam where permission/feature flags get threaded into `enabled` predicates.
// `Record<string, never>` rather than `{}`: the empty OBJECT type, not the
// any-non-nullish type `{}` actually means — a `0` or a `""` must not satisfy
// this. Add capability fields here and every `enabled` predicate can read them.
export type MentionCapabilities = Record<string, never>;

export interface MentionSource extends EntitySuggestionSource {
  enabled: (caps: MentionCapabilities) => boolean;
  slash: { title: string; icon: IconName };
}

// Single switch for which entity kinds the @-mention people menu offers, in
// tab order. Drop a kind here and it disappears from the picker — paired with
// the server-side allow-list in MentionNotificationsService.extractMentions (decides
// who actually gets notified), this is the one place to enable/disable a
// mentionable entity. Teams are intentionally excluded: members only.
export const MENTIONABLE_ENTITY_KINDS: readonly EntityKind[] = ["user"];

export const MENTION_SOURCES: readonly MentionSource[] = [
  {
    char: "@",
    kind: "user",
    pluginKey: PEOPLE_KEY,
    enabled: () => true,
    slash: { title: "Mention a person", icon: "at-sign" },
  },
];

export function getEnabledMentionSources(
  caps: MentionCapabilities = {},
): MentionSource[] {
  return MENTION_SOURCES.filter((source) => source.enabled(caps));
}
